import React, { Component } from 'react';
import { Form, Input } from 'antd';
import displayServerErrors from '../../../utilities/form/display_server_errors';

const FormItem = Form.Item;
const { TextArea } = Input;

export default class FaqAnswerForm extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  async submitData() {
    try {
      this.setState({ loading: true });
      const {data} = await this.props.mutate(this.props.mutationParams());
      this.props.redirectTo(data);
    } catch(response) {
      displayServerErrors(this.props.form, response);
    } finally {
      this.setState({ loading: false });
    }
  }

  onSubmit(event) {
    event.preventDefault();

    this.props.form.validateFields((error, _values) => {
      if (!error) {
        this.submitData();
      }
    });
  }

  getFaqAnswerField(name) {
    return this.props.faqAnswer ? this.props.faqAnswer[name] : undefined;
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div>
        <div className="dashboard-layout__placeholder"/>
        <div className="m-24">
          <Form onSubmit={this.onSubmit.bind(this)} className="login-form">
            <h1 className="login-form__header">FAQ Answer</h1>
            <FormItem>
              {getFieldDecorator('question', {
                initialValue: this.getFaqAnswerField('question'),
                rules: [
                  { required: true, message: 'Please input question' }
                ],
              })(
                <TextArea placeholder="Question" rows={4} />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('answer', {
                initialValue: this.getFaqAnswerField('answer'),
                rules: [
                  { required: true, message: 'Please input answer' }
                ],
              })(
                <TextArea placeholder="Answer" rows={10} />
              )}
            </FormItem>

            <FormItem>
              { this.props.formControls(this.state.loading) }
            </FormItem>
          </Form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/faqAnswers/faqAnswerForm.js